import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Components/Pages/Home2';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy';

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
